import { useEffect, useRef, useState } from 'react';
import FlightInfoRow from './FlightInfoRow';

export const DeferredFlightInfoRow = ({
  className,
  flight,
  kind,
  isSelected,
  onSelect,
  isBookingPage = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={className} ref={rowRef}>
      {isVisible ? (
        <FlightInfoRow
          flight={flight}
          isBookingPage={isBookingPage}
          isSelected={isSelected}
          kind={kind}
          onSelect={onSelect}
        />
      ) : (
        <div style={{ height: '100px' }} /> // Placeholder mientras carga
      )}
    </div>
  );
};
